import React from 'react'
import { useSelector } from 'APP/Hooks/redux'
import Analytics from 'APP/Services/Analytics'
import I18n from 'APP/I18n'
import sprigClient from 'APP/Services/Sprig'
import { PrimaryButton } from 'APP/Components/Buttons'

const ANALYTICS = {
  JOIN_CHALLENGE: 'WELLNESS_CENTER_JOINED_CHALLENGE',
}

const JoinButton = ({ setVisibility, toggleTeamModal, ...props }) => {
  const { challenge, joining } = useSelector((state) => state.wellnessCenter.selectedChallenge)

  const joinChallenge = () => {
    Analytics.trackEvent('button_click', {
      button_value: 'Join challenge',
      trigger: `Join challenge id: ${challenge.id}`,
    })
    sprigClient.track(ANALYTICS.JOIN_CHALLENGE)

    toggleTeamModal?.(true)
  }

  return (
    <PrimaryButton
      {...props}
      title={I18n.t('WellnessCenter.challenges.join')}
      disabled={joining}
      onPress={joinChallenge}
      testID="JOIN_CHALLENGE_BTN"
    />
  )
}

export default JoinButton
